<template>
    <div :class="apptype == 'Roewe' ? 'rw_grame' : 'mg_grame'" :style="styleOverflew">
        <!-- 返回按钮 -->
        <div class="close_page" @click="closepage"></div>
        <div class="content">
            <img :style="'transform: translate('+coordinate.left+' , '+coordinate.top+')'" class="vile-character" :src="vileCharacter" alt="">
        </div>
        <!-- 唤起任务弹框 -->
        <div class="assingment" @click="assingmentFun"></div>
        <!-- 骰子 -->
        <div class="frame">
            <div class="dice-box flex align-items-center justify-content-center">
                <img @click="shakeElbows" class="dice" :class="dicerotate?'dice-mg':''" :src="diceSrc" alt="">
            </div>
            <div class="residue-degree">剩余次数：{{residueDegree}}次</div>
        </div>
        <div class="toast" v-if="toastPopup">{{toastContent}}</div>
        <div class="mask" v-if="assignmentPopup || acquisitionIntegral || officialDocumentsCorrespondence || thanksParticipation || prizeacquisitionIntegral">
            <!-- 任务弹框 -->
            <div class="assignment-popup positionabsolute" v-if="assignmentPopup">
                <div class="forum-interaction"><span :class="interactionStatus==2?'forum-unfinished':'forum-completed'" @click="foruminteraction"></span></div>
                <div class="share-frequency"><span :class="shareStatus==2?'share-unfinished':'share-completed'" @click="sharefrequency"></span></div>
                <div class="attention-commodity"><span :class="attentionStatus==2?'attention-unfinished':'attention-completed'" @click="attentioncommodity"></span></div>
                <div class="close-acquisition" @click="closeassignmentPopup"></div>
            </div>
            <!-- 积分弹框 -->
            <div class="acquisition-integral positionabsolute" v-if="acquisitionIntegral">
                <div class="close-acquisition" @click="closeacquisitionIntegral"></div>
                <div class="acquisition-title">恭喜您获得{{acquisitionTitle}}</div>
                <img :src="prizeImg" alt="" class="prize-img">
                <div class="prize-title">{{acquisitionTitle}}</div>
                <div class="confirm-btn" @click="closeacquisitionIntegral"></div>
            </div>
            <!-- 奖品弹框弹框 -->
            <div class="prizeacquisition-integral positionabsolute" v-if="prizeacquisitionIntegral">
                <div class="close-acquisition" @click="closeprizeacquisitionIntegral"></div>
                <div class="acquisition-title">恭喜您获得{{prizeacquisitionTitle}}</div>
                <img :src="prizeImg" alt="" class="prize-img">
                <div class="prize-title">{{acquisitionTitle}}</div>
                <div class="confirm-btn" @click="deliveryAddressFun(acquisitionTitle)"></div>
            </div>
            <!-- 文案弹框 -->
            <div class="official-documents-correspondence positionabsolute flex align-items-center justify-content-center flex-wrap" v-if="officialDocumentsCorrespondence">
                <div class="title1">{{officialHearTitle}}</div>
                <div class="title">{{officialTitle}}</div>
                <div class="close" @click="closeofficialDocumentsCorrespondence"></div>
            </div>
            <!-- 谢谢参与弹框 -->
            <div class="thanks-participation positionabsolute" v-if="thanksParticipation">
                <div class="confirm-btn" @click="closethanksParticipation"></div>
                <div class="close-acquisition" @click="closethanksParticipation"></div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery'
export default {
    data(){
        return{
            prizeacquisitionIntegral:false,  //获得奖品弹框
            thanksParticipation:false,  //谢谢参与弹框
            officialHearTitle:'2021.11.1-2021.11.20',  //福利消息的时间
            officialTitle:'客官在线下购买原厂保养套餐，会赠送赠送奖品价值30元京东卡。要记得备注注册的app与注册手机号哦~核销后会以票券形式发放~例：“荣威+188 8888 8888”', //文案弹框内容
            officialDocumentsCorrespondence:false,  //文案弹框
            prizeImg:'https://res.xiaoxxx.com/test/m.xiaoxxx.com/202110284a396d54e225d9cb278572.png',  //奖品图
            acquisitionTitle:'卡西欧2021 BATTLE G-SHOCK 王一博同款',  //奖品名称
            prizeacquisitionTitle:'卡西欧手表',  //奖品名
            acquisitionIntegral:false,  //积分弹框
            assignmentPopup:false,  //任务弹框
            residueDegree:0,  //剩余掷骰子次数
            dicerotate:false,  //骰子转动
            toastPopup:false,
            toastContent:'',
            styleOverflew:'overflow: scroll;',
            apptype: "Roewe",  //roewe为名荣威  mg为名爵
            userToken:window.localStorage.getItem('zebra-token'),
            // userToken:'215d5d3290ac47ae9d76b63636c62126-prod_SAIC',
            userToken:'301def62d54140149bbf6962c8e85a4c-prod_SAIC',
            coordinate:{
                left: '0rem',
                top: '0rem',
                scrollLeft:7880,
                scrollTop:270,
                dice:'https://res.xiaoxxx.com/test/m.xiaoxxx.com/2021102511740a977a3243c2857914.png',
                vileCharacter1:'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211025b94347c715f3817f113010.png',
                vileCharacter2:'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211026bab8f141d4f90145304306.png',
                adversative:1
            },
            setGridsFun:[
                {
                    index:0,scrollLeft:270,scrollTop:0,left: '0rem',top: '0rem',dice:'//res.xiaoxxx.com/test/m.xiaoxxx.com/2021102511740a977a3243c2857914.png',vileCharacter1:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211025b94347c715f3817f113010.png',vileCharacter2:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211026bab8f141d4f90145304306.png',adversative:1,title:'开始',content:'文案内容',pointNum:'',category:''
                },
                {
                    index:1,scrollLeft:210,scrollTop:150,left: '-4rem',top: '-2.4rem',dice:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110251a0bfd07448c21d6555573.png',vileCharacter1:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211025b94347c715f3817f113010.png',vileCharacter2:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211026bab8f141d4f90145304306.png',adversative:1,title:'积分',content:'叮~50积分到账',pointNum:50,category:1
                },
                {
                    index:2,scrollLeft:140,scrollTop:200,left: '-5.8rem',top: '-3.4rem',dice:'//res.xiaoxxx.com/test/m.xiaoxxx.com/2021102511740a977a3243c2857914.png',vileCharacter1:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211025b94347c715f3817f113010.png',vileCharacter2:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211026bab8f141d4f90145304306.png',adversative:1,title:'福利消息',time:'2021.11.1-2021.11.30',content:'活动期间，客官购买原厂保养商品，前10000名完成核销即可获得8000积分，第10001~20000名完成核销可获得6000积分~',pointNum:'',category:3
                },
                {
                    index:3,scrollLeft:0,scrollTop:310,left: '-9.4rem',top: '-5.9rem',dice:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110251a0bfd07448c21d6555573.png',vileCharacter1:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110250a58e1e72f80d26b418562.png',vileCharacter2:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211026b39e63a71c30988b774701.png',adversative:1,title:'随机礼包',content:'恭喜你获得xxx/呀，没抽到，不要气馁，后面惊喜更多~',pointNum:'',category:2
                },
                {
                    index:4,scrollLeft:40,scrollTop:400,left: '-7.4rem',top: '-7.2rem',dice:'//res.xiaoxxx.com/test/m.xiaoxxx.com/2021102511740a977a3243c2857914.png',vileCharacter1:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110250a58e1e72f80d26b418562.png',vileCharacter2:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211026b39e63a71c30988b774701.png',adversative:1,title:'福利消息',time:'11.11 11:11',content:'活动期间，客官购买原厂保养商品并完成核销，前50名用（以付款时间排序）可获得返还积分的福利哦～',pointNum:'',category:3
                },
                {
                    index:5,scrollLeft:230,scrollTop:480,left: '-3.8rem',top: '-9.3rem',dice:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110251a0bfd07448c21d6555573.png',vileCharacter1:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110250a58e1e72f80d26b418562.png',vileCharacter2:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211026b39e63a71c30988b774701.png',adversative:1,title:'积分',content:'叮~50积分到账',pointNum:50,category:1
                },
                {
                    index:6,scrollLeft:310,scrollTop:530,left: '-2rem',top: '-10.3rem',dice:'//res.xiaoxxx.com/test/m.xiaoxxx.com/2021102511740a977a3243c2857914.png',vileCharacter1:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110250a58e1e72f80d26b418562.png',vileCharacter2:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211026b39e63a71c30988b774701.png',adversative:1,title:'随机礼包',content:'恭喜你获得xxx/呀，没抽到，不要气馁，后面惊喜更多~',pointNum:'',category:2
                },
                {
                    index:7,scrollLeft:350,scrollTop:630,left: '0',top: '-11.8rem',dice:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110251a0bfd07448c21d6555573.png',
                    vileCharacter1:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211025b94347c715f3817f113010.png',vileCharacter2:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211026bab8f141d4f90145304306.png',adversative:0,pointNum:'',category:''
                },//转折
                {
                    index:7,scrollLeft:300,scrollTop:650,left: '-2rem',top: '-13.1rem',dice:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110251a0bfd07448c21d6555573.png',vileCharacter1:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211025b94347c715f3817f113010.png',vileCharacter2:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211026bab8f141d4f90145304306.png',adversative:1,title:'福利消息',time:'2021.11.1-2021.11.30',content:'客官购买1件商品85折的活动，2件商品75折的活动哦~客官千万别错过啦~',pointNum:'',category:3
                },
                {
                    index:8,scrollLeft:150,scrollTop:750,left: '-5.6rem',top: '-15.2rem',dice:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110251a0bfd07448c21d6555573.png',
                    vileCharacter1:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211025b94347c715f3817f113010.png',vileCharacter2:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211026bab8f141d4f90145304306.png',adversative:1,title:'积分',content:'叮~50积分到账',pointNum:50,category:1
                },
                {
                    index:9,scrollLeft:0,scrollTop:870,left: '-9.3rem',top: '-17.6rem',dice:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110251a0bfd07448c21d6555573.png',vileCharacter1:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110250a58e1e72f80d26b418562.png',vileCharacter2:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211026b39e63a71c30988b774701.png',adversative:1,title:'随机礼包',content:'恭喜你获得xxx/呀，没抽到，不要气馁，后面惊喜更多~',pointNum:'',category:2
                },
                {
                    index:10,scrollLeft:50,scrollTop:930,left: '-7.3rem',top: '-18.9rem',dice:'//res.xiaoxxx.com/test/m.xiaoxxx.com/2021102511740a977a3243c2857914.png',
                    vileCharacter1:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110250a58e1e72f80d26b418562.png',vileCharacter2:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211026b39e63a71c30988b774701.png',adversative:1,title:'福利消息',time:'2021.11.1-2021.11.30',content:'客官购买原厂精品附件，单笔订单满400元（且在11月30日前确认收货后）可兑换十月活动兑换券内奖品哦~',pointNum:'',category:3
                },
                {
                    index:11,scrollLeft:240,scrollTop:1050,left: '-3.7rem',top: '-21.1rem',dice:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110251a0bfd07448c21d6555573.png',vileCharacter1:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110250a58e1e72f80d26b418562.png',vileCharacter2:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211026b39e63a71c30988b774701.png',adversative:1,title:'积分',content:'叮~50积分到账',pointNum:50,category:1
                },
                {
                    index:12,scrollLeft:300,scrollTop:1100,left: '-2rem',top: '-22.1rem',dice:'//res.xiaoxxx.com/test/m.xiaoxxx.com/2021102511740a977a3243c2857914.png',vileCharacter1:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110250a58e1e72f80d26b418562.png',vileCharacter2:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211026b39e63a71c30988b774701.png',adversative:1,title:'随机礼包',content:'恭喜你获得xxx/呀，没抽到，不要气馁，后面惊喜更多~',pointNum:'',category:2
                },
                {
                    index:13,scrollLeft:350,scrollTop:1150,left: '0rem',top: '-23.5rem',dice:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110251a0bfd07448c21d6555573.png',vileCharacter1:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211025b94347c715f3817f113010.png',vileCharacter2:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211026bab8f141d4f90145304306.png',adversative:0,pointNum:'',category:''
                },//转折
                {
                    index:13,scrollLeft:300,scrollTop:1220,left: '-2rem',top: '-24.9rem',dice:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110251a0bfd07448c21d6555573.png',vileCharacter1:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211025b94347c715f3817f113010.png',vileCharacter2:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211026bab8f141d4f90145304306.png',adversative:1,title:'福利消息',time:'2021.11.1-2021.11.30',content:'客官购买商品成交金额消费最高的前11名（不含刷单）核销后即可获得嘉实多终身保养体验官名额~',pointNum:'',category:3
                },
                {
                    index:14,scrollLeft:150,scrollTop:1350,left: '-5.6rem',top: '-27rem',dice:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110251a0bfd07448c21d6555573.png',vileCharacter1:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211025b94347c715f3817f113010.png',vileCharacter2:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211026bab8f141d4f90145304306.png',adversative:1,title:'积分',content:'叮~50积分到账',pointNum:50,category:1
                },
                {
                    index:15,scrollLeft:0,scrollTop:1450,left: '-9.3rem',top: '-29.4rem',dice:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110251a0bfd07448c21d6555573.png',vileCharacter1:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110250a58e1e72f80d26b418562.png',vileCharacter2:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211026b39e63a71c30988b774701.png',adversative:1,title:'随机礼包',content:'恭喜你获得xxx/呀，没抽到，不要气馁，后面惊喜更多~',pointNum:'',category:2
                },
                {
                    index:16,scrollLeft:70,scrollTop:1500,left: '-7.2rem',top: '-30.8rem',dice:'//res.xiaoxxx.com/test/m.xiaoxxx.com/2021102511740a977a3243c2857914.png',vileCharacter1:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110250a58e1e72f80d26b418562.png',vileCharacter2:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211026b39e63a71c30988b774701.png',adversative:1,title:'福利消息',time:'2021.11.1-2021.11.30',content:'11月10日更有嘉实多双十一直播专场，直播期间也有嘉实多终身保养体验官的名额哦~',pointNum:'',category:3
                },
                {
                    index:17,scrollLeft:270,scrollTop:1600,left: '-3.8rem',top: '-32.9rem',dice:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110251a0bfd07448c21d6555573.png',vileCharacter1:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110250a58e1e72f80d26b418562.png',vileCharacter2:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211026b39e63a71c30988b774701.png',adversative:1,title:'积分',content:'叮~50积分到账',pointNum:50,category:1
                },
                {
                    index:18,scrollLeft:310,scrollTop:1650,left: '-2rem',top: '-33.9rem',dice:'//res.xiaoxxx.com/test/m.xiaoxxx.com/2021102511740a977a3243c2857914.png',vileCharacter1:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110250a58e1e72f80d26b418562.png',vileCharacter2:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211026b39e63a71c30988b774701.png',adversative:1,title:'随机礼包',content:'恭喜你获得xxx/呀，没抽到，不要气馁，后面惊喜更多~',pointNum:'',category:2
                },
                {
                    index:19,scrollLeft:350,scrollTop:1710,left: '0rem',top: '-35.4rem',dice:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110251a0bfd07448c21d6555573.png',vileCharacter1:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211025b94347c715f3817f113010.png',vileCharacter2:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211026bab8f141d4f90145304306.png',adversative:0,pointNum:'',category:''
                },//转折
                {
                    index:19,scrollLeft:320,scrollTop:1800,left: '-1.8rem',top: '-36.7rem',dice:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110251a0bfd07448c21d6555573.png',vileCharacter1:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211025b94347c715f3817f113010.png',vileCharacter2:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211026bab8f141d4f90145304306.png',adversative:1,title:'福利消息',time:'2021.11.1-2021.11.20',content:'客官在线下购买原厂保养套餐，会赠送赠送奖品价值30元京东卡。要记得备注注册的app与注册手机号哦~核销后会以票券形式发放~例：“荣威+188 8888 8888”',pointNum:'',category:3
                },
                {
                    index:20,scrollLeft:150,scrollTop:1900,left: '-5.4rem',top: '-38.8rem',dice:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110251a0bfd07448c21d6555573.png',vileCharacter1:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211025b94347c715f3817f113010.png',vileCharacter2:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211026bab8f141d4f90145304306.png',adversative:1,title:'积分',content:'叮~50积分到账',pointNum:50,category:1
                },
                {
                    index:21,scrollLeft:0,scrollTop:2020,left: '-9.3rem',top: '-41.3rem',dice:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110251a0bfd07448c21d6555573.png',vileCharacter1:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110250a58e1e72f80d26b418562.png',vileCharacter2:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211026b39e63a71c30988b774701.png',adversative:1,title:'随机礼包',content:'恭喜你获得xxx/呀，没抽到，不要气馁，后面惊喜更多~',pointNum:'',category:2
                },
                {
                    index:22,scrollLeft:100,scrollTop:2070,left: '-7.3rem',top: '-42.6rem',dice:'//res.xiaoxxx.com/test/m.xiaoxxx.com/2021102511740a977a3243c2857914.png',vileCharacter1:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110250a58e1e72f80d26b418562.png',vileCharacter2:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211026b39e63a71c30988b774701.png',adversative:1,title:'福利消息',time:'2021.11.1-2021.11.30',content:'我们会赠送大额代金券，部分精品8折起哦~记得关注',pointNum:'',category:3
                },
                {
                    index:23,scrollLeft:250,scrollTop:2170,left: '-3.7rem',top: '-44.7rem',dice:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110251a0bfd07448c21d6555573.png',vileCharacter1:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110250a58e1e72f80d26b418562.png',vileCharacter2:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211026b39e63a71c30988b774701.png',adversative:1,title:'积分',content:'叮~50积分到账',pointNum:50,category:1
                },
                {
                    index:24,scrollLeft:310,scrollTop:2250,left: '-1.9rem',top: '-45.7rem',dice:'//res.xiaoxxx.com/test/m.xiaoxxx.com/2021102511740a977a3243c2857914.png',vileCharacter1:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110250a58e1e72f80d26b418562.png',vileCharacter2:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211026b39e63a71c30988b774701.png',adversative:1,title:'随机礼包',content:'恭喜你获得xxx/呀，没抽到，不要气馁，后面惊喜更多~',pointNum:'',category:2
                },
                {
                    index:25,scrollLeft:360,scrollTop:2300,left: '0.4rem',top: '-47.1rem',dice:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110251a0bfd07448c21d6555573.png',vileCharacter1:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211025b94347c715f3817f113010.png',vileCharacter2:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211026bab8f141d4f90145304306.png',adversative:0
                },//转折
                {
                    index:25,scrollLeft:310,scrollTop:2350,left: '-1.7rem',top: '-48.5rem',dice:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110251a0bfd07448c21d6555573.png',vileCharacter1:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211025b94347c715f3817f113010.png',vileCharacter2:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211026bab8f141d4f90145304306.png',adversative:1,title:'福利消息',time:'',content:'关注11.11在直播间有超多好礼等你来赢',pointNum:'',category:3
                },
                {
                    index:26,scrollLeft:150,scrollTop:2450,left: '-5.3rem',top: '-50.6rem',dice:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110251a0bfd07448c21d6555573.png',vileCharacter1:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211025b94347c715f3817f113010.png',vileCharacter2:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211026bab8f141d4f90145304306.png',adversative:1,title:'积分',content:'叮~50积分到账',pointNum:50,category:1
                },
                {
                    index:27,scrollLeft:0,scrollTop:2570,left: '-9.5rem',top: '-53rem',dice:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110251a0bfd07448c21d6555573.png',vileCharacter1:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110250a58e1e72f80d26b418562.png',vileCharacter2:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211026b39e63a71c30988b774701.png',adversative:1,title:'随机礼包',content:'恭喜你获得xxx/呀，没抽到，不要气馁，后面惊喜更多~',pointNum:'',category:2
                },
                {
                    index:28,scrollLeft:50,scrollTop:2650,left: '-7.4rem',top: '-54.4rem',dice:'//res.xiaoxxx.com/test/m.xiaoxxx.com/2021102511740a977a3243c2857914.png',vileCharacter1:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110250a58e1e72f80d26b418562.png',vileCharacter2:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211026b39e63a71c30988b774701.png',adversative:1,title:'福利消息',time:'',content:'听说11.1-11.20在直播间会有1折秒杀商品，并且商城内每天会推出3款，每款限量10份哦~',pointNum:'',category:3
                },
                {
                    index:29,scrollLeft:250,scrollTop:2750,left: '-3.9rem',top: '-56.5rem',dice:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110251a0bfd07448c21d6555573.png',vileCharacter1:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110250a58e1e72f80d26b418562.png',vileCharacter2:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211026b39e63a71c30988b774701.png',adversative:1,title:'积分',content:'叮~50积分到账',pointNum:50,category:1
                },
                {
                    index:30,scrollLeft:300,scrollTop:2800,left: '-2.1rem',top: '-57.5rem',dice:'//res.xiaoxxx.com/test/m.xiaoxxx.com/2021102511740a977a3243c2857914.png',vileCharacter1:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110250a58e1e72f80d26b418562.png',vileCharacter2:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211026b39e63a71c30988b774701.png',adversative:1,title:'随机礼包',content:'恭喜你获得xxx/呀，没抽到，不要气馁，后面惊喜更多~',pointNum:'',category:2
                },
                {
                    index:31,scrollLeft:360,scrollTop:2850,left: '0.1rem',top: '-59rem',dice:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110251a0bfd07448c21d6555573.png',vileCharacter1:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211025b94347c715f3817f113010.png',vileCharacter2:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211026bab8f141d4f90145304306.png',adversative:0,pointNum:'',category:''
                },//转折
                {
                    index:31,scrollLeft:310,scrollTop:2920,left: '-1.9rem',top: '-60.3rem',dice:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110251a0bfd07448c21d6555573.png',vileCharacter1:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211025b94347c715f3817f113010.png',vileCharacter2:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211026bab8f141d4f90145304306.png',adversative:1,title:'福利消息',time:'2021.11.1-2021.11.30',content:'客官购买2件商品会有两件75折的活动哦~客官千万别错过啦~',pointNum:'',category:3
                },
                {
                    index:32,scrollLeft:150,scrollTop:3050,left: '-5.5rem',top: '-62.4rem',dice:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110251a0bfd07448c21d6555573.png',vileCharacter1:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211025b94347c715f3817f113010.png',vileCharacter2:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211026bab8f141d4f90145304306.png',adversative:1,title:'积分',content:'叮~50积分到账',pointNum:50,category:1
                },
                {
                    index:33,scrollLeft:0,scrollTop:3150,left: '-9.5rem',top: '-64.8rem',dice:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110251a0bfd07448c21d6555573.png',vileCharacter1:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110250a58e1e72f80d26b418562.png',vileCharacter2:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211026b39e63a71c30988b774701.png',adversative:1,title:'随机礼包',content:'恭喜你获得xxx/呀，没抽到，不要气馁，后面惊喜更多~',pointNum:'',category:2
                },
                {
                    index:34,scrollLeft:50,scrollTop:3200,left: '-7.5rem',top: '-66.2rem',dice:'//res.xiaoxxx.com/test/m.xiaoxxx.com/2021102511740a977a3243c2857914.png',vileCharacter1:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110250a58e1e72f80d26b418562.png',vileCharacter2:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211026b39e63a71c30988b774701.png',adversative:1,title:'积分',content:'叮~22积分到账',pointNum:22,category:1
                },
                {
                    index:35,scrollLeft:250,scrollTop:3320,left: '-3.8rem',top: '-68.3rem',dice:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110251a0bfd07448c21d6555573.png',vileCharacter1:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110250a58e1e72f80d26b418562.png',vileCharacter2:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211026b39e63a71c30988b774701.png',adversative:1,title:'积分',content:'叮~66积分到账',pointNum:66,category:1
                },
                {
                    index:36,scrollLeft:300,scrollTop:3400,left: '-2rem',top: '-69.2rem',dice:'//res.xiaoxxx.com/test/m.xiaoxxx.com/2021102511740a977a3243c2857914.png',vileCharacter1:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110250a58e1e72f80d26b418562.png',vileCharacter2:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211026b39e63a71c30988b774701.png',adversative:1,title:'随机礼包',content:'恭喜你获得xxx/呀，没抽到，不要气馁，后面惊喜更多~',pointNum:'',category:2
                },
                {
                    index:37,scrollLeft:360,scrollTop:3450,left: '0.2rem',top: '-70.7rem',dice:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110251a0bfd07448c21d6555573.png',vileCharacter1:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211025b94347c715f3817f113010.png',vileCharacter2:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211026bab8f141d4f90145304306.png',adversative:0,pointNum:'',category:''
                },//转折
                {
                    index:37,scrollLeft:300,scrollTop:3500,left: '-1.8rem',top: '-72.1rem',dice:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110251a0bfd07448c21d6555573.png',vileCharacter1:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211025b94347c715f3817f113010.png',vileCharacter2:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211026bab8f141d4f90145304306.png',adversative:1,title:'积分',content:'叮~22积分到账',pointNum:22,category:1
                },
                {
                    index:38,scrollLeft:150,scrollTop:3600,left: '-5.3rem',top: '-74.2rem',dice:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110251a0bfd07448c21d6555573.png',vileCharacter1:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211025b94347c715f3817f113010.png',vileCharacter2:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211026bab8f141d4f90145304306.png',adversative:1,title:'积分',content:'叮~66积分到账',pointNum:66,category:1
                },
                {
                    index:39,scrollLeft:0,scrollTop:3700,left: '-9.5rem',top: '-76.5rem',dice:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110251a0bfd07448c21d6555573.png',vileCharacter1:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110250a58e1e72f80d26b418562.png',vileCharacter2:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211026b39e63a71c30988b774701.png',adversative:1,title:'随机礼包',content:'恭喜你获得xxx/呀，没抽到，不要气馁，后面惊喜更多~',pointNum:'',category:2
                },
                {
                    index:40,scrollLeft:100,scrollTop:3750,left: '-7.4rem',top: '-78rem',dice:'//res.xiaoxxx.com/test/m.xiaoxxx.com/2021102511740a977a3243c2857914.png',vileCharacter1:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110250a58e1e72f80d26b418562.png',vileCharacter2:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211026b39e63a71c30988b774701.png',adversative:1,title:'福利消息',time:'',content:'至2021.12.28 23：59过期积分将全部清零，客官有没有把积分用完呢~',pointNum:'',category:3
                },
                {
                    index:41,scrollLeft:250,scrollTop:3870,left: '-3.9rem',top: '-80rem',dice:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110251a0bfd07448c21d6555573.png',vileCharacter1:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110250a58e1e72f80d26b418562.png',vileCharacter2:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211026b39e63a71c30988b774701.png',adversative:1,title:'积分',content:'叮~50积分到账',pointNum:50,category:1
                },
                {
                    index:42,scrollLeft:310,scrollTop:3950,left: '-2rem',top: '-81.1rem',dice:'//res.xiaoxxx.com/test/m.xiaoxxx.com/2021102511740a977a3243c2857914.png',vileCharacter1:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110250a58e1e72f80d26b418562.png',vileCharacter2:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211026b39e63a71c30988b774701.png',adversative:1,title:'随机礼包',content:'恭喜你获得xxx/呀，没抽到，不要气馁，后面惊喜更多~',pointNum:'',category:2
                },
                {
                    index:43,scrollLeft:360,scrollTop:4000,left: '0.1rem',top: '-82.6rem',dice:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110251a0bfd07448c21d6555573.png',vileCharacter1:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211025b94347c715f3817f113010.png',vileCharacter2:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211026bab8f141d4f90145304306.png',adversative:0,pointNum:'',category:''
                }, //转折
                {
                    index:43,scrollLeft:310,scrollTop:4050,left: '-1.7rem',top: '-84rem',dice:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110251a0bfd07448c21d6555573.png',vileCharacter1:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211025b94347c715f3817f113010.png',vileCharacter2:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211026bab8f141d4f90145304306.png',adversative:1,title:'积分',content:'叮~66积分到账',pointNum:66,category:1
                },
                {
                    index:44,scrollLeft:150,scrollTop:4150,left: '-5.3rem',top: '-86.1rem',dice:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110251a0bfd07448c21d6555573.png',vileCharacter1:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211025b94347c715f3817f113010.png',vileCharacter2:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211026bab8f141d4f90145304306.png',adversative:1,title:'积分',content:'叮~22积分到账',pointNum:22,category:1
                },
                {
                    index:45,scrollLeft:0,scrollTop:4270,left: '-9.5rem',top: '-88.5rem',dice:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110251a0bfd07448c21d6555573.png',vileCharacter1:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110250a58e1e72f80d26b418562.png',vileCharacter2:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211026b39e63a71c30988b774701.png',adversative:1,title:'随机礼包',content:'恭喜你获得xxx/呀，没抽到，不要气馁，后面惊喜更多~',pointNum:'',category:2
                },
                {
                    index:46,scrollLeft:100,scrollTop:4350,left: '-7.3rem',top: '-89.9rem',dice:'//res.xiaoxxx.com/test/m.xiaoxxx.com/2021102511740a977a3243c2857914.png',vileCharacter1:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110250a58e1e72f80d26b418562.png',vileCharacter2:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211026b39e63a71c30988b774701.png',adversative:1,title:'积分',content:'叮~66积分到账',pointNum:66,category:1
                },
                {
                    index:47,scrollLeft:250,scrollTop:4450,left: '-3.7rem',top: '-91.9rem',dice:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110251a0bfd07448c21d6555573.png',vileCharacter1:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110250a58e1e72f80d26b418562.png',vileCharacter2:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211026b39e63a71c30988b774701.png',adversative:1,title:'积分',content:'叮~22积分到账',pointNum:22,category:1
                },
                {
                    index:48,scrollLeft:310,scrollTop:4520,left: '-2rem',top: '-92.9rem',dice:'//res.xiaoxxx.com/test/m.xiaoxxx.com/2021102511740a977a3243c2857914.png',vileCharacter1:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110250a58e1e72f80d26b418562.png',vileCharacter2:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211026b39e63a71c30988b774701.png',adversative:1,title:'随机礼包',content:'恭喜你获得xxx/呀，没抽到，不要气馁，后面惊喜更多~',pointNum:'',category:2
                },
                {
                    index:49,scrollLeft:350,scrollTop:4600,left: '0rem',top: '-94.5rem',dice:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110251a0bfd07448c21d6555573.png',vileCharacter1:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211025b94347c715f3817f113010.png',vileCharacter2:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211026bab8f141d4f90145304306.png',adversative:0,pointNum:'',category:''
                },  //转折
                {
                    index:49,scrollLeft:300,scrollTop:4650,left: '-1.8rem',top: '-95.9rem',dice:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110251a0bfd07448c21d6555573.png',vileCharacter1:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211025b94347c715f3817f113010.png',vileCharacter2:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211026bab8f141d4f90145304306.png',adversative:1,title:'积分',content:'叮~66积分到账',pointNum:66,category:1
                },
                {
                    index:50,scrollLeft:150,scrollTop:4750,left: '-5.4rem',top: '-98rem',dice:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110251a0bfd07448c21d6555573.png',vileCharacter1:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211025b94347c715f3817f113010.png',vileCharacter2:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211026bab8f141d4f90145304306.png',adversative:1,title:'积分',content:'叮~22积分到账',pointNum:22,category:1
                },
                {
                    index:51,scrollLeft:0,scrollTop:4870,left: '-9.5rem',top: '-100.4rem',dice:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110251a0bfd07448c21d6555573.png',vileCharacter1:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110250a58e1e72f80d26b418562.png',vileCharacter2:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211026b39e63a71c30988b774701.png',adversative:1,title:'随机礼包',content:'恭喜你获得xxx/呀，没抽到，不要气馁，后面惊喜更多~',pointNum:'',category:2
                },
                {
                    index:52,scrollLeft:100,scrollTop:4950,left: '-7.4rem',top: '-101.7rem',dice:'//res.xiaoxxx.com/test/m.xiaoxxx.com/2021102511740a977a3243c2857914.png',vileCharacter1:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110250a58e1e72f80d26b418562.png',vileCharacter2:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211026b39e63a71c30988b774701.png',adversative:1,title:'积分',content:'叮~22积分到账',pointNum:22,category:1
                },
                {
                    index:53,scrollLeft:250,scrollTop:5050,left: '-3.8rem',top: '-103.8rem',dice:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110251a0bfd07448c21d6555573.png',vileCharacter1:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110250a58e1e72f80d26b418562.png',vileCharacter2:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211026b39e63a71c30988b774701.png',adversative:1,title:'积分',content:'叮~66积分到账',pointNum:66,category:1
                },
                {
                    index:54,scrollLeft:310,scrollTop:5100,left: '-2rem',top: '-104.9rem',dice:'//res.xiaoxxx.com/test/m.xiaoxxx.com/2021102511740a977a3243c2857914.png',vileCharacter1:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110250a58e1e72f80d26b418562.png',vileCharacter2:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211026b39e63a71c30988b774701.png',adversative:1,title:'随机礼包',content:'恭喜你获得xxx/呀，没抽到，不要气馁，后面惊喜更多~',pointNum:'',category:2
                },
                {
                    index:55,scrollLeft:350,scrollTop:5150,left: '0rem',top: '-106.4rem',dice:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110251a0bfd07448c21d6555573.png',vileCharacter1:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211025b94347c715f3817f113010.png',vileCharacter2:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211026bab8f141d4f90145304306.png',adversative:0,pointNum:'',category:''
                },//转折
                {
                    index:55,scrollLeft:300,scrollTop:5200,left: '-1.8rem',top: '-107.7rem',dice:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110251a0bfd07448c21d6555573.png',vileCharacter1:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211025b94347c715f3817f113010.png',vileCharacter2:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211026bab8f141d4f90145304306.png',adversative:1,title:'积分',content:'叮~22积分到账',pointNum:22,category:1
                },
                {
                    index:56,scrollLeft:150,scrollTop:5300,left: '-5.4rem',top: '-109.8rem',dice:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110251a0bfd07448c21d6555573.png',vileCharacter1:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211025b94347c715f3817f113010.png',vileCharacter2:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211026bab8f141d4f90145304306.png',adversative:1,title:'积分',content:'叮~66积分到账',pointNum:66,category:1
                },
                {
                    index:57,scrollLeft:0,scrollTop:5420,left: '-9.4rem',top: '-112.3rem',dice:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110251a0bfd07448c21d6555573.png',vileCharacter1:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110250a58e1e72f80d26b418562.png',vileCharacter2:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211026b39e63a71c30988b774701.png',adversative:1,title:'随机礼包',content:'恭喜你获得xxx/呀，没抽到，不要气馁，后面惊喜更多~',pointNum:'',category:2
                },
                {
                    index:58,scrollLeft:100,scrollTop:5500,left: '-7.4rem',top: '-113.6rem',dice:'//res.xiaoxxx.com/test/m.xiaoxxx.com/2021102511740a977a3243c2857914.png',vileCharacter1:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110250a58e1e72f80d26b418562.png',vileCharacter2:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211026b39e63a71c30988b774701.png',adversative:1,title:'积分',content:'叮~22积分到账',pointNum:22,category:1
                },
                {
                    index:59,scrollLeft:250,scrollTop:5600,left: '-3.8rem',top: '-115.7rem',dice:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110251a0bfd07448c21d6555573.png',vileCharacter1:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110250a58e1e72f80d26b418562.png',vileCharacter2:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211026b39e63a71c30988b774701.png',adversative:1,title:'积分',content:'叮~66积分到账',pointNum:66,category:1
                },
                {
                    index:60,scrollLeft:300,scrollTop:5650,left: '-2rem',top: '-116.7rem',dice:'//res.xiaoxxx.com/test/m.xiaoxxx.com/2021102511740a977a3243c2857914.png',vileCharacter1:'//res.xiaoxxx.com/test/m.xiaoxxx.com/202110250a58e1e72f80d26b418562.png',vileCharacter2:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211026b39e63a71c30988b774701.png',adversative:1,title:'随机礼包',content:'恭喜你获得xxx/呀，没抽到，不要气馁，后面惊喜更多~',pointNum:'',category:2
                },
                {
                    index:60,scrollLeft:350,scrollTop:5700,left: '0rem',top: '-118.1rem',dice:'//res.xiaoxxx.com/test/m.xiaoxxx.com/2021102511740a977a3243c2857914.png',vileCharacter1:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211025b94347c715f3817f113010.png',vileCharacter2:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211026bab8f141d4f90145304306.png',adversative:1,title:'福利消息',content:'',pointNum:'',category:3
                },
            ],
            vileCharacter:'',  //小人左
            diceSrc:'//res.xiaoxxx.com/test/m.xiaoxxx.com/2021102511740a977a3243c2857914.png',  //骰子
            diceNum:26,  //当前的游戏进度
            nextreturn: true,  //防止多次点击
            prizeInfo:[],   //奖品信息
            address:{},  //地址信息
            scrollTopMessage:0,
            shareTitle:'',  //分享文案
            shareLink:'',  //分享链接
            shareImge:'',  //分享图
            shareStatus:2,  //今天是否已经参与过分享
            interactionStatus:2,  //今天是否已经参与过论坛互动
            attentionStatus:2,  //今天是否已经参与过商品关注
            scource:window.localStorage.getItem('scource'),
            timeout:2,  //活动是否已结束，2未结束1已结束
        }
    },
    created(){
        // this.getUserInfolist()
        this.getUserToken()
        
        this.apptype = 'MG'
        if (this.apptype == "Roewe") {
            this.vileCharacter = 'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211026bab8f141d4f90145304306.png'
            require("../../public/css/grame-rw.less");
        } else {
            this.vileCharacter = 'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211025b94347c715f3817f113010.png'
            require("../../public/css/grame-mg.less");
        }
    },
    mounted() {
        if(this.apptype=='Roewe'){
            document.querySelector('.rw_grame').scrollTop = 10000
            document.querySelector('.rw_grame').scrollLeft = 270
            this.scrollTopMessage = document.querySelector('.rw_grame').scrollTop
            this.shareTitle='车主狂欢节 荣威11.11'
            this.shareLink='https://gio.ren/d8jZ?path=/RouterManager/openCustomWebViewController/publicService&params=eyJVUkwiOiJodHRwczovL2g1Y2FzZTQueGlhb3h4eC5jbi8yMDIxMTEvcm9ld2UvZGlzdC9pbmRleC5odG1sIn0='
            this.shareImge='https://res.xiaoxxx.com/test/m.xiaoxxx.com/2021102876d47aa75bbc585d664669.jpg'
            
        }else{
            document.querySelector('.mg_grame').scrollTop = 10000
            document.querySelector('.mg_grame').scrollLeft = 270
            this.scrollTopMessage = document.querySelector('.mg_grame').scrollTop
            this.shareTitle='车主狂欢节 名爵11.11'
            this.shareLink='https://gio.ren/dOGQ?path=/mgBase/baseDsBridgePage&params=eyJrZXlfZHNfdXJsIjoiaHR0cHM6Ly9oNWNhc2U0LnhpYW94eHguY24vMjAyMTExL21nL2Rpc3QvaW5kZXguaHRtbCIsImtleV9kc19uYXZpZ2F0aW9uX2JhciI6IjIiLCJrZXlfZHNfdGl0bGUiOiLlkI3niLUifQ=='
            this.shareImge='https://res.xiaoxxx.com/test/m.xiaoxxx.com/2021102890e8a7e19c0550f3455279.jpg'
        }
    },
    methods:{
        time(){
            var td=new Date();
            var d=td.getDate();
            if(d==2||d==6||d==10||d==14||d==18||d==22){
                // 美孚保养套餐
                if(this.apptype=='Roewe'){
                    window.location.href = 'https://prw.anyolife.com/goods-detail/2c908af179d2e9150179f619a8e04756?RWfrom=app?sourceFrom=RWApp'
                }else{
                    window.location.href = 'https://mg.anyolife.com/goods-detail/2c908af379f6801c0179f6898e680001'
                }
            }else if(d==3||d==7||d==11||d==15||d==19||d==23){
                // 臻选保养套餐
                if(this.apptype=='Roewe'){
                    window.location.href = 'https://prw.anyolife.com/goods-detail/2c908af379d2d97c0179f5d6446e304f?RWfrom=app?sourceFrom=RWApp'
                }else{
                    window.location.href = 'https://mg.anyolife.com/goods-detail/2c908af179d2e9150179f660e71d47bc'
                }
            }else if(d==4||d==8||d==12||d==16||d==20||d==24){
                // 壳牌原厂保养
                if(this.apptype=='Roewe'){
                    window.location.href = 'https://prw.anyolife.com/goods-detail/4748821b7c931e1e017cbf82bc51289d?RWfrom=app'
                }else{
                    window.location.href = 'https://mg.anyolife.com/goods-detail/2c908af37c931539017cbf7f9fb945a7'
                }
            }else if(d==5||d==9||d==13||d==17||d==21){
                // 嘉实多保养套餐
                if(this.apptype=='Roewe'){
                    window.location.href = 'https://prw.anyolife.com/goods-detail/2c908af379d2d97c0179f5f73c91307e?RWfrom=app?sourceFrom=RWApp'
                }else{
                    window.location.href = 'https://mg.anyolife.com/goods-detail/2c908af179d2e9150179f6302ba44775'
                }
            }
        },
        // 返回上一页
        closepage(){
            this.$router.replace({
                name: "Home",
            });
        },
        // 关闭奖品弹框
        closeprizeacquisitionIntegral(){
            this.styleOverflew='overflow: scroll;'
            this.prizeacquisitionIntegral = false
            if(this.diceNum==69){
                this.shakeElbowstwo()
            }
        },
        // 关闭谢谢参与弹框
        closethanksParticipation(){
            this.styleOverflew='overflow: scroll;'
            this.thanksParticipation = false
            if(this.diceNum==69){
                this.shakeElbowstwo()
            }
        },
        // 唤起任务弹框
        assingmentFun(){
            this.styleOverflew='overflow: hidde;'
            this.assignmentPopup = true
        },
        // 关闭文案弹框
        closeofficialDocumentsCorrespondence(){
            this.styleOverflew='overflow: scroll;'
            this.officialDocumentsCorrespondence = false
        },
        // 关闭积分弹框
        closeacquisitionIntegral(){
            this.styleOverflew='overflow: scroll;'
            this.acquisitionIntegral = false
            if(this.diceNum==69){
                this.shakeElbowstwo()
            }
        },
        // 关闭任务弹框
        closeassignmentPopup(){
            this.styleOverflew='overflow: scroll;'
            this.assignmentPopup = false
        },
        // 去填写收货地址
        deliveryAddressFun(data){
            if(data && data!=1){
                this.prizeInfo.push(data)
            }
            if (this.apptype == "Roewe") {
                this.$router.push({path:'/rwAddress'})
            } else {
                this.$router.push({path:'/mgAddress'})
            }
        },
        // 分享获得次数
        sharefrequency(){
            if(this.timeout==1){
                this.assignmentPopup =false
                this.styleOverflew='overflow: scroll;'
                this.toastContent = '活动已结束'
                this.toastPopup = true
                setTimeout(() => {
                    this.toastPopup = false
                    this.toastContent = ''
                }, 1500);
                return false
            }
            if(this.nextreturn){
                this.nextreturn = false
                if(this.shareStatus==1){
                    return false
                }
                this.$http.post("/completeShare", {
                    brandCode: "2", // 1:荣威，2:名爵
                    token: this.userToken,
                }).then((res) => {
                    this.nextreturn = true
                    if(res.data.code==0){
                        window._czc.push(["_trackEvent", this.scource, "分享获得游戏次数", '1', "1", "1"]);
                        this.assignmentPopup =false
                        this.styleOverflew='overflow: scroll;'
                        share( this.shareTitle, '', this.shareLink, this.shareImge, 3)
                        this.getUserInfolist()
                    }else{
                        this.assignmentPopup =false
                        this.styleOverflew='overflow: scroll;'
                        if(this.hasLetter(res.data.message)){
                            this.toastContent = '系统繁忙，请稍后再试'
                            this.toastPopup = true
                            setTimeout(() => {
                                this.toastPopup = false
                                this.toastContent = ''
                            }, 1500);
                            return false
                        }
                        this.toastContent = res.data.message
                        this.toastPopup = true
                        setTimeout(() => {
                            this.toastPopup = false
                            this.toastContent = ''
                        }, 1500);
                    }
                })
            }
            
        },
        // 论坛互动获得次数
        foruminteraction(){
            if(this.timeout==1){
                this.assignmentPopup =false
                this.styleOverflew='overflow: scroll;'
                this.toastContent = '活动已结束'
                this.toastPopup = true
                setTimeout(() => {
                    this.toastPopup = false
                    this.toastContent = ''
                }, 1500);
                return false
            }
            if(this.nextreturn){
                this.nextreturn = false
                if(this.interactionStatus==1){
                    return false
                }
                this.$http.post("/completeForum", {
                    brandCode: "2", // 1:荣威，2:名爵
                    token: this.userToken,
                }).then((res) => {
                    this.nextreturn = true
                    if(res.data.code==0){
                        window._czc.push(["_trackEvent", this.scource, "论坛互动获得游戏次数", '1', "1", "1"]);
                        // this.assignmentPopup =false
                        // this.styleOverflew='overflow: scroll;'
                        // this.toastContent = '论坛互动成功'
                        //     this.toastPopup = true
                        //     setTimeout(() => {
                        //         this.toastPopup = false
                        //         this.toastContent = ''
                        //         this.getUserInfolist()
                        //     }, 1500);
                        if(this.apptype=='Roewe'){
                            window.location.href = 'https://social.roewe.com.cn/saicui/defaultTemp?id=4590'
                        }else{
                            window.location.href = 'https://social.saicmg.com/saicui/mg-news?id=4565'
                        }
                    }else{
                        this.assignmentPopup =false
                        this.styleOverflew='overflow: scroll;'
                        if(this.hasLetter(res.data.message)){
                            this.toastContent = '系统繁忙，请稍后再试'
                            this.toastPopup = true
                            setTimeout(() => {
                                this.toastPopup = false
                                this.toastContent = ''
                            }, 1500);
                            return false
                        }
                        this.toastContent = res.data.message
                        this.toastPopup = true
                        setTimeout(() => {
                            this.toastPopup = false
                            this.toastContent = ''
                        }, 1500);
                    }
                })
            }
            
        },
        // 关注商品获得次数
        attentioncommodity(){
            if(this.timeout==1){
                this.assignmentPopup =false
                this.styleOverflew='overflow: scroll;'
                this.toastContent = '活动已结束'
                this.toastPopup = true
                setTimeout(() => {
                    this.toastPopup = false
                    this.toastContent = ''
                }, 1500);
                return false
            }
            if(this.nextreturn){
                this.nextreturn = false
                if(this.attentionStatus==1){
                    return false
                }
                this.$http.post("/completeFocus", {
                    brandCode: "2", // 1:荣威，2:名爵
                    token: this.userToken,
                }).then((res) => {
                    this.nextreturn = true
                    if(res.data.code==0){
                        window._czc.push(["_trackEvent", this.scource, "关注商品获得次数", '1', "1", "1"]);
                        // this.assignmentPopup =false
                        // this.styleOverflew='overflow: scroll;'
                        // this.toastContent = '关注商品成功'
                        //     this.toastPopup = true
                        //     setTimeout(() => {
                        //         this.toastPopup = false
                        //         this.toastContent = ''
                        //         this.getUserInfolist()
                        //     }, 1500);
                        this.time()
                        // if(this.apptype=='Roewe'){
                        //     window.location.href = 'https://prw.anyolife.com/goods-detail/2c908af179d2e9150179f619a8e04756?RWfrom=app?sourceFrom=RWApp'
                        // }else{
                        //     window.location.href = 'https://mg.anyolife.com/goods-detail/2c908af379f6801c0179f6898e680001'
                        // }
                    }else{
                        this.assignmentPopup =false
                        this.styleOverflew='overflow: scroll;'
                        if(this.hasLetter(res.data.message)){
                            this.toastContent = '系统繁忙，请稍后再试'
                            this.toastPopup = true
                            setTimeout(() => {
                                this.toastPopup = false
                                this.toastContent = ''
                            }, 1500);
                            return false
                        }
                        this.toastContent = res.data.message
                        this.toastPopup = true
                        setTimeout(() => {
                            this.toastPopup = false
                            this.toastContent = ''
                        }, 1500);
                    }
                })
            }
            
        },
        shakeElbowstwo(){
            this.diceNum++
            this.diceSrc = ''
            this.diceSrc = this.setGridsFun[this.diceNum].dice
            this.coordinate = this.setGridsFun[this.diceNum]
            if(this.apptype=='Roewe'){
                // $('.rw_grame').animate({scrollTop: this.coordinate.scrollTop,scrollLeft: this.coordinate.scrollLeft}, 1500);
                $('.rw_grame').animate({scrollTop: (this.scrollTopMessage - this.coordinate.scrollTop),scrollLeft: this.coordinate.scrollLeft}, 1500);
            }else{
                $('.mg_grame').animate({scrollTop: (this.scrollTopMessage - this.coordinate.scrollTop),scrollLeft: this.coordinate.scrollLeft}, 1500);
                // $('.mg_grame').animate({scrollTop: this.coordinate.scrollTop,scrollLeft: this.coordinate.scrollLeft}, 1500);
            }
            setTimeout(() => { 
                this.vileCharacter = ''
                if(this.apptype=='Roewe'){
                    this.vileCharacter = this.setGridsFun[this.diceNum].vileCharacter2
                }else{
                    this.vileCharacter = this.setGridsFun[this.diceNum].vileCharacter1
                }
                this.nextreturn = true
                if(this.setGridsFun[this.diceNum].adversative==0){
                    this.diceNum++
                    this.diceSrc = ''
                    this.diceSrc = this.setGridsFun[this.diceNum].dice
                    this.coordinate = this.setGridsFun[this.diceNum]
                    this.nextreturn = false
                    if(this.apptype=='Roewe'){
                        $('.rw_grame').animate({scrollTop: (this.scrollTopMessage - this.coordinate.scrollTop),scrollLeft: this.coordinate.scrollLeft}, 1500);
                        // $('.rw_grame').animate({scrollTop: this.coordinate.scrollTop,scrollLeft: this.coordinate.scrollLeft}, 1500);
                    }else{
                        $('.mg_grame').animate({scrollTop: (this.scrollTopMessage - this.coordinate.scrollTop),scrollLeft: this.coordinate.scrollLeft}, 1500);
                        // $('.mg_grame').animate({scrollTop: this.coordinate.scrollTop,scrollLeft: this.coordinate.scrollLeft}, 1500);
                    }
                    setTimeout(() => {
                        this.vileCharacter = ''
                        if(this.apptype=='Roewe'){
                            this.vileCharacter = this.setGridsFun[this.diceNum].vileCharacter2
                        }else{
                            this.vileCharacter = this.setGridsFun[this.diceNum].vileCharacter1
                        }
                        this.nextreturn = true
                        setTimeout(() => {
                            this.getGrameList()                                    
                        }, 500);
                    }, 1500);
                }else{
                    setTimeout(() => {
                        this.getGrameList()
                    }, 500);
                }
                
            }, 1500);
        },
        shakeElbows(){
            if(this.timeout==1){
                this.assignmentPopup =false
                this.styleOverflew='overflow: scroll;'
                this.toastContent = '活动已结束'
                this.toastPopup = true
                setTimeout(() => {
                    this.toastPopup = false
                    this.toastContent = ''
                }, 1500);
                return false
            }
            if(this.residueDegree==0){
                this.toastContent = '机会已用尽'
                this.toastPopup = true
                setTimeout(() => {
                    this.toastPopup = false
                    this.toastContent = ''
                }, 1500);
                return false
            }
            if(this.diceNum==this.setGridsFun.length-1){
                return
            }
            
            if(this.nextreturn){
                window._czc.push(["_trackEvent", this.scource, "点击骰子玩游戏", '1', "1", "1"]);
                this.nextreturn = false
                this.dicerotate = true
                this.diceNum++
                this.diceSrc = ''
                this.diceSrc = this.setGridsFun[this.diceNum].dice
                setTimeout(() => {
                    this.coordinate = this.setGridsFun[this.diceNum]
                    this.dicerotate = false
                    if(this.apptype=='Roewe'){
                        // $('.rw_grame').animate({scrollTop: this.coordinate.scrollTop,scrollLeft: this.coordinate.scrollLeft}, 1500);
                        $('.rw_grame').animate({scrollTop: (this.scrollTopMessage - this.coordinate.scrollTop),scrollLeft: this.coordinate.scrollLeft}, 1500);
                    }else{
                        $('.mg_grame').animate({scrollTop: (this.scrollTopMessage - this.coordinate.scrollTop),scrollLeft: this.coordinate.scrollLeft}, 1500);
                        // $('.mg_grame').animate({scrollTop: this.coordinate.scrollTop,scrollLeft: this.coordinate.scrollLeft}, 1500);
                    }
                    setTimeout(() => { 
                        this.vileCharacter = ''
                        if(this.apptype=='Roewe'){
                            this.vileCharacter = this.setGridsFun[this.diceNum].vileCharacter2
                        }else{
                            this.vileCharacter = this.setGridsFun[this.diceNum].vileCharacter1
                        }
                        this.nextreturn = true
                        if(this.setGridsFun[this.diceNum].adversative==0){
                            this.nextreturn = false
                            this.diceNum++
                            this.diceSrc = ''
                            this.diceSrc = this.setGridsFun[this.diceNum].dice
                            this.coordinate = this.setGridsFun[this.diceNum]
                            if(this.apptype=='Roewe'){
                                $('.rw_grame').animate({scrollTop: (this.scrollTopMessage - this.coordinate.scrollTop),scrollLeft: this.coordinate.scrollLeft}, 1500);
                                // $('.rw_grame').animate({scrollTop: this.coordinate.scrollTop,scrollLeft: this.coordinate.scrollLeft}, 1500);
                            }else{
                                $('.mg_grame').animate({scrollTop: (this.scrollTopMessage - this.coordinate.scrollTop),scrollLeft: this.coordinate.scrollLeft}, 1500);
                                // $('.mg_grame').animate({scrollTop: this.coordinate.scrollTop,scrollLeft: this.coordinate.scrollLeft}, 1500);
                            }
                            setTimeout(() => {
                                this.vileCharacter = ''
                                if(this.apptype=='Roewe'){
                                    this.vileCharacter = this.setGridsFun[this.diceNum].vileCharacter2
                                }else{
                                    this.vileCharacter = this.setGridsFun[this.diceNum].vileCharacter1
                                }
                                this.nextreturn = true
                                setTimeout(() => {
                                    this.getGrameList()                                    
                                }, 500);
                            }, 1500);
                        }else{
                            setTimeout(() => {
                                this.getGrameList()
                            }, 500);
                        }
                        
                    }, 1500);
                }, 1000);
            }
        },
        // 游戏接口
        getGrameList(){
            let obj = {}
            if(this.coordinate.title=='积分'){
                obj={
                    brandCode: "2", // 1:荣威，2:名爵
                    token: this.userToken,
                    gameProgress:this.diceNum,
                    pointNum:this.coordinate.pointNum,
                    category:this.coordinate.category
                }
            }else if(this.coordinate.title=='随机礼包' || this.coordinate.title=='福利消息'){
                obj={
                    brandCode: "2", // 1:荣威，2:名爵
                    token: this.userToken,
                    gameProgress:this.diceNum,
                    category:this.coordinate.category
                }
            }
            this.$http.post("/rollDice", obj).then((res) => {
                if(res.data.code==0){
                    this.residueDegree--
                    if(this.coordinate.category==1){
                        window._czc.push(["_trackEvent", this.scource, "获得积分", this.coordinate.pointNum + '积分', "1", "1"]);
                        this.prizeImg='//res.xiaoxxx.com/test/m.xiaoxxx.com/202110284a396d54e225d9cb278572.png'
                        this.acquisitionTitle=this.coordinate.pointNum + '积分'
                        this.acquisitionIntegral = true
                        this.styleOverflew='overflow: hidden;'
                    }else if(this.coordinate.category==2){
                        window._czc.push(["_trackEvent", this.scource, "获得随机礼包", res.data.data.prizeInfo.prize_name, "1", "1"]);
                        if(res.data.data.prizeInfo.prize_name=='谢谢参与'){
                            this.thanksParticipation = true
                            this.styleOverflew='overflow: hidden;'
                        }else if(res.data.data.prizeInfo.prize_name=='50积分'){
                            this.prizeImg='//res.xiaoxxx.com/test/m.xiaoxxx.com/202110284a396d54e225d9cb278572.png'
                            this.acquisitionTitle='50积分'
                            this.acquisitionIntegral = true
                            this.styleOverflew='overflow: hidden;'
                        }else if(res.data.data.prizeInfo.prize_name=='酷我音乐月卡'){
                            this.prizeImg='//res.xiaoxxx.com/test/m.xiaoxxx.com/202110289f808dad59bbb3e2157283.png'
                            this.acquisitionTitle=res.data.data.prizeInfo.prize_name
                            this.acquisitionIntegral = true
                            this.styleOverflew='overflow: hidden;'
                        }else if(res.data.data.prizeInfo.prize_name=='猫眼电影券'){
                            this.prizeImg='//res.xiaoxxx.com/test/m.xiaoxxx.com/20211028bb80d570b49a4533334650.png'
                            this.acquisitionTitle=res.data.data.prizeInfo.prize_name
                            this.acquisitionIntegral = true
                            this.styleOverflew='overflow: hidden;'
                        }else if(res.data.data.prizeInfo.prize_name=='大嘴猴 Paul Frank 保温杯'){
                            this.prizeImg='https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211028094b847e9d389a32878374.png'
                            this.acquisitionTitle=res.data.data.prizeInfo.prize_name
                            this.prizeacquisitionTitle = '保温杯'
                            this.prizeacquisitionIntegral = true
                            this.styleOverflew='overflow: hidden;'
                        }else if(res.data.data.prizeInfo.prize_name=='米家桌面暖风机'){
                            this.prizeImg='https://res.xiaoxxx.com/test/m.xiaoxxx.com/2021102856eff1aae09c7547245857.png'
                            this.acquisitionTitle=res.data.data.prizeInfo.prize_name
                            this.prizeacquisitionTitle = '暖风机'
                            this.prizeacquisitionIntegral = true
                            this.styleOverflew='overflow: hidden;'
                        }else if(res.data.data.prizeInfo.prize_name=='卡西欧2021 BATTLE G-SHOCK 王一博同款'){
                            this.prizeImg='https://res.xiaoxxx.com/test/m.xiaoxxx.com/202110280289c785eaab2053820259.png'
                            this.acquisitionTitle=res.data.data.prizeInfo.prize_name
                            this.prizeacquisitionTitle = '卡西欧手表'
                            this.prizeacquisitionIntegral = true
                            this.styleOverflew='overflow: hidden;'
                        }else if(res.data.data.prizeInfo.prize_name=='Airpods pro'){
                            this.prizeImg='https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211028fa7d81863e39b70a405751.png'
                            this.acquisitionTitle=res.data.data.prizeInfo.prize_name
                            this.prizeacquisitionIntegral = true
                            this.prizeacquisitionTitle = 'Airpods pro'
                            this.styleOverflew='overflow: hidden;'
                        }else if(res.data.data.prizeInfo.prize_name=='车载吸尘器套装'){
                            this.prizeImg='https://res.xiaoxxx.com/test/m.xiaoxxx.com/2021102830627dc6ff8334b9633200.png'
                            this.acquisitionTitle=res.data.data.prizeInfo.prize_name
                            this.prizeacquisitionTitle = '车载吸尘器'
                            this.prizeacquisitionIntegral = true
                            this.styleOverflew='overflow: hidden;'
                        }
                        
                    }else if(this.coordinate.category==3){
                        window._czc.push(["_trackEvent", this.scource, "获得福利消息", '', "1", "1"]);
                        if(this.coordinate.content){
                            this.officialTitle = this.coordinate.content
                            this.officialHearTitle = this.coordinate.time
                            this.officialDocumentsCorrespondence =true
                            this.styleOverflew='overflow: hidden;'

                        }
                    }
                }else{
                    this.diceNum--
                    this.diceSrc = ''
                    this.diceSrc = this.setGridsFun[this.diceNum].dice
                    this.coordinate = this.setGridsFun[this.diceNum]
                    if(this.apptype=='Roewe'){
                        $('.rw_grame').animate({scrollTop: (this.scrollTopMessage - this.coordinate.scrollTop),scrollLeft: this.coordinate.scrollLeft}, 1500);
                        // $('.rw_grame').animate({scrollTop: this.coordinate.scrollTop,scrollLeft: this.coordinate.scrollLeft}, 1500);
                    }else{
                        $('.mg_grame').animate({scrollTop: (this.scrollTopMessage - this.coordinate.scrollTop),scrollLeft: this.coordinate.scrollLeft}, 1500);
                        // $('.mg_grame').animate({scrollTop: this.coordinate.scrollTop,scrollLeft: this.coordinate.scrollLeft}, 1500);
                    }
                    setTimeout(() => {
                        this.vileCharacter = ''
                        if(this.apptype=='Roewe'){
                            this.vileCharacter = this.setGridsFun[this.diceNum].vileCharacter2
                        }else{
                            this.vileCharacter = this.setGridsFun[this.diceNum].vileCharacter1
                        }
                    }, 1500);
                    if(this.hasLetter(res.data.message)){
                        this.toastContent = '系统繁忙，请稍后再试'
                        this.toastPopup = true
                        setTimeout(() => {
                            this.toastPopup = false
                            this.toastContent = ''
                        }, 1500);
                        return false
                    }
                    this.styleOverflew='overflow: scroll;'
                    this.toastContent = res.data.message
                    this.toastPopup = true
                    setTimeout(() => {
                        this.toastPopup = false
                        this.toastContent = ''
                    }, 1500);
                }
            })
        },
        // 未登陆时调用去登录页面
        backToApp() {
            window.serviceError("14101", (res) => {
                console.log(res);
            });
        },
        // 获取用户token
        getUserToken() {
            window.getToken(this.callback);
        },
        // getToken回调
        callback(res) {
            if (res.token) {
                // setInterval(() => {
                //     console.log("token，", res.token);
                // }, 5000);
                window.localStorage.setItem('zebra-token',res.token)
                this.userToken = res.token;
                this.getUserInfolist();
            } else {
                // console.log("token为空");
                this.backToApp();
            }
        },
        // 判断接口是否返回全为英文
        hasLetter(str) {
            for (var i in str) {
                var asc = str.charCodeAt(i);
                if ((asc >= 65 && asc <= 90 || asc >= 97 && asc <= 122)) {
                    return true;
                }
            }
            return false;
        },
        getUserInfolist(){
            this.$http.post("/getInfo", {
              brandCode: "2", // 1:荣威，2:名爵
                token: this.userToken,
            }).then((res) => {
                if(res.data.code==0){
                    this.timeout = res.data.data.timeout
                    window.localStorage.setItem('Authorization',res.data.data.H5Token)
                    // res.data.data.prizeInfo.map((v)=>{
                    //     this.prizeInfo.push(v.prize_name)
                    // })
                    if(res.data.data.info.chance){
                        this.residueDegree = res.data.data.info.chance
                    }
                    // this.address = res.data.data.info.address || {}
                    this.shareStatus = res.data.data.taskOneStatus
                    this.interactionStatus = res.data.data.taskTwoStatus
                    this.attentionStatus = res.data.data.taskThreeStatus
                    this.diceNum = res.data.data.info.game_progress
                    if(this.diceNum>0){
                        this.diceSrc = ''
                        this.diceSrc = this.setGridsFun[this.diceNum].dice
                        this.coordinate = this.setGridsFun[this.diceNum]
                        if(this.apptype=='Roewe'){
                            $('.rw_grame').animate({scrollTop: (this.scrollTopMessage - this.coordinate.scrollTop),scrollLeft: this.coordinate.scrollLeft}, 1500);
                            // $('.rw_grame').animate({scrollTop: this.coordinate.scrollTop,scrollLeft: this.coordinate.scrollLeft}, 1500);
                        }else{
                            $('.mg_grame').animate({scrollTop: (this.scrollTopMessage - this.coordinate.scrollTop),scrollLeft: this.coordinate.scrollLeft}, 1500);
                            // $('.mg_grame').animate({scrollTop: this.coordinate.scrollTop,scrollLeft: this.coordinate.scrollLeft}, 1500);
                        }
                        setTimeout(() => {
                            this.vileCharacter = ''
                            if(this.apptype=='Roewe'){
                                this.vileCharacter = this.setGridsFun[this.diceNum].vileCharacter2
                            }else{
                                this.vileCharacter = this.setGridsFun[this.diceNum].vileCharacter1
                            }
                        }, 1500);

                    }
                }
            })
        }
    }
}
</script>
